import moment from 'moment'

export default {
    methods: {
        TranslatePlaceholders(objectSettings, content) {
            objectSettings?.forEach(s => {
                switch (s.valueType) {
                    case 'date':
                        content = content?.replace(`%${s.valueKey}%`, moment(s.value)?.format('DD/MM/YYYY'));
                        break;
                    case 'longDate':
                        content = content?.replace(`%${s.valueKey}%`, moment(s.value)?.format('dddd, D MMMM YYYY'));
                        break;
                    case 'currency':
                        content = content?.replace(`%${s.valueKey}%`, s.value.toFixed(2));
                        break;
                    default:
                        content = content?.replace(`%${s.valueKey}%`, s.value);
                        break;
                }
            });

            return content;
        },
    },
};